<script lang="ts" setup>
import { MediaImageFragment, ParagraphLogoSidebar } from '~/api/graphql/generated'

defineProps<{
  entity: ParagraphLogoSidebar
}>()
</script>
<template>
  <LogoSidebar :image="entity.fieldImage?.entity as MediaImageFragment" />
</template>
